import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { IconModule, PaginationComponent, SpinnerModule, TabParagraphContainerModule } from "@spartacus/storefront";

@Component({
  selector: 'gen-pagination',
  templateUrl: './pagination.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    I18nModule,
    IconModule,
    SpinnerModule,
    TabParagraphContainerModule,
  ],
})
export class GenPaginationComponent extends PaginationComponent { }
